/* 
		This is a repository for Regular Expressions. There has been a few instances where 
		they have been reused. So, instead of search where you might have used one 
		and copy it, you now just have a class with all of them.

		import { RegExHelper } from "{add other dirs here}/_helpers/regex-helper";
		constructor( private regExHelper: RegExHelper) {}
*/
export class RegExHelper {
  public customPattern:         RegExp;
  public looseEmailPattern:     RegExp;
  public namePattern:           RegExp;
  public noSpacePattern:        RegExp;
  public passwordRulesPattern:  Record<string, RegExp>;
  public policyPattern:         RegExp;
  public legacyPolicyPattern:   RegExp;
  public strictEmailPattern:    RegExp;
  public strictEmailPatternV1:    RegExp;
  public numberPattern: RegExp;
  
  constructor(){
    this.customPattern =        / /;
    this.looseEmailPattern =    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.strictEmailPattern =   /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/;
    this.noSpacePattern =       /^\s*$/;
    this.namePattern =          /^[a-zA-Z-'\s]*$/;///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;  // /^((?!\_)[A-z]+((-)*[A-z])*)$/;
    this.policyPattern =        /^[a-zA-Z0-9\s]+$/; ///^[A-z0-9]+$/;
    this.legacyPolicyPattern =  /^[a-zA-Z0-9]+[a-zA-Z0-9-][a-zA-Z0-9]+$/;
    this.numberPattern =        /^[0-9]+$/;
    this.passwordRulesPattern = {
      'ruleOne':    /^(?=.*[a-z])/g,
      'ruleTwo':    /^(?=.*[0-9])/g,
      'ruleThree':  /[^A-Za-z0-9]+/g,
      'ruleFour':   /^(?=.{7,})/g,
      'ruleSix':   /^(?=.*[A-Z])/g,
      'all':        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/g,
      'patternForDynamicForm': /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])/g
    };
  }

  public regExPasswordStrength(rule: string, value: string): any {
    if( 
      (value != undefined || value != null || value != '' || value !== undefined || value !== null) 
      && this.passwordRulesPattern[rule].test(value) 
    ) return true;
  }

}

